module.exports = __webpack_public_path__ + "static/media/p-overframe.9bfb5d67.png";